import { gql } from "@apollo/client";

export const DELETE_COMMENT = gql`
  mutation deleteComment($input: DeleteCommentInput!) {
    deleteComment(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ADD_COMMENT = gql`
  mutation addComment($input: AddCommentInput!) {
    addComment(input: $input) {
      commandId
      correlationId
    }
  }
`;
